import React, { Component } from 'react';

import PhoneInput from 'react-phone-number-input';
import { getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import {FlagFr, FlagUs} from '../../images'

class InputPhoneNumberMispari extends Component {
  constructor() {
    super();
    this.state = { phone: "" };
  }

  onChange(phone){
    console.log(phone)
    const { changeFieldValue } = this.props
     const number = phone ? phone.replace(/^\+3333|\+33033/g, "33") : "";
     const phoneNumber = number.replace(/^\+|\s+$/g, "") ;
     changeFieldValue('mispari', 'forwardNumber', "newNumber")
     changeFieldValue(this.props.meta.form, this.props.input.name, phoneNumber)
  }
  render(){
    const { currentLanguage, error, touched } = this.props;
    let defaultCountry = "US";
    if (currentLanguage === "fr_FR"){
      defaultCountry ="FR"
    }
    const countries = ["US", "FR",]
    return (
        <div className="nput-group" style={ {   verticalAlign: "baseline",}} >
        <PhoneInput
          flagsPath="https://lipis.github.io/flag-icons/flags/4x3/"
          country={defaultCountry}
          countries={countries}
          placeholder={this.props.initvalue }
          onChange={ phone => this.onChange( phone ) }
          type="phone"
          />
        {touched && error && <div><span className="text-danger">{error}</span></div>}
        </div>

    );
  }
}

const viewMapStateToProps = (state) => {
  return{
    currentLanguage: getActiveLanguage(state.locale).code
  }
}

const viewMapDispatchToProps = (dispatch) => {

  return {
    changeFieldValue: (form, field, value) => {
      dispatch(
        change(form, field, value)
      );
    },
  };
};
InputPhoneNumberMispari = connect(
  viewMapStateToProps,
  viewMapDispatchToProps,
)(InputPhoneNumberMispari);

export default InputPhoneNumberMispari;



// WEBPACK FOOTER //
// ./src/lib/forms/InputPhoneNumberMispari.js